const SidebarPosition = {
  el: {
    root: document.querySelectorAll('.layout')
  },
  
  init() {
    if(this.el.root) {
      this.el.root.forEach((target) => {
        const el = {
          layout: target,
          sidebar: target.querySelector('.layout__sidebar') as HTMLElement,
          divider: target.querySelector('.layout__divider'),
          sidebarContent: target.querySelector('.layout__sidebar > .side-navigation') as HTMLElement,
          content: target.querySelector('.layout__content > .subpage__content') as HTMLElement,
        }

        if (el.sidebar && el.sidebarContent?.clientHeight < el.content?.clientHeight) {
          let run = false
          let bottomPosition = el.sidebar.parentElement.getBoundingClientRect().bottom - (el.sidebar.offsetHeight + 40)
          
          if (window.innerWidth >= 1200) {
            run = true
          }
          
          document.addEventListener('resize', () => {
            if (window.innerWidth >= 1200) {
              run = true
            } else {
              run = false
            }
          })
          
          if (run) {
            this.positionSidebar(el, bottomPosition)

            document.addEventListener('scroll', () => {
              bottomPosition = el.sidebar.parentElement.getBoundingClientRect().bottom - (el.sidebar.offsetHeight + 40)

              this.positionSidebar(el, bottomPosition)
            })
          }
        }
      })
    }
    
  },
  
  positionSidebar: (el, bottomPosition) => {
    const widthWithoutGap = el.sidebar.parentElement.offsetWidth - 11 * 30
    const gapWidth = 30
    const colWidth = widthWithoutGap / 12

    if (bottomPosition <= 0) {
      el.sidebar.style.top = `${
        el.sidebar.parentElement.getBoundingClientRect().bottom - (el.sidebar.offsetHeight + 100)
      }px`
    } else if (el.layout.getBoundingClientRect().top <= -60) {
      el.sidebar.style.top = '-60px'
    }

    if (el.layout.getBoundingClientRect().top <= -60) {
      el.layout.classList.add('layout--fixed')
      el.sidebar.style.width = `${colWidth * 3 + gapWidth * 2}px`
    } else {
      el.layout.classList.remove('layout--fixed')
    }
  },
}

export default SidebarPosition
